import { createAuthClient } from 'better-auth/vue'

export type AuthClient = ReturnType<typeof createAuthClient>
export type SocialAuthProvider = 'discord' | 'twitch'

export function createBetterAuthClient(baseURL: string): AuthClient {
  return createAuthClient({
    baseURL,
  })
}

/**
 * Build a same-origin, non-secret entrypoint for native social sign-in.
 * Better Auth creates its signed state only after this relay reaches the
 * configured auth origin, so neither the provider URL nor state enters JS.
 */
export function getSocialSignInRelayUrl(
  provider: SocialAuthProvider,
  streamerApiBaseURL: string,
  authBaseURL: string,
  callbackURL: string,
): string {
  let streamerApiUrl: URL
  let authUrl: URL
  let callbackUrl: URL
  try {
    streamerApiUrl = new URL(streamerApiBaseURL)
    authUrl = new URL(authBaseURL)
    callbackUrl = new URL(callbackURL)
  } catch {
    throw new Error('Social sign-in navigation unavailable')
  }

  if (
    !['http:', 'https:'].includes(streamerApiUrl.protocol) ||
    !['http:', 'https:'].includes(authUrl.protocol) ||
    !['http:', 'https:'].includes(callbackUrl.protocol) ||
    streamerApiUrl.username ||
    streamerApiUrl.password ||
    streamerApiUrl.search ||
    streamerApiUrl.hash ||
    authUrl.username ||
    authUrl.password ||
    authUrl.search ||
    authUrl.hash ||
    callbackUrl.username ||
    callbackUrl.password ||
    callbackUrl.hash
  ) {
    throw new Error('Social sign-in navigation unavailable')
  }

  const streamerApiPath = streamerApiUrl.pathname.replace(/\/+$/, '')
  streamerApiUrl.pathname = `${streamerApiPath}/v2/runtime/social-sign-in/${provider}`
  streamerApiUrl.searchParams.set('authBaseURL', authUrl.toString())
  streamerApiUrl.searchParams.set(
    'callbackURL',
    callbackUrl.pathname === '/' && !callbackUrl.search ? callbackUrl.origin : callbackUrl.toString(),
  )
  return streamerApiUrl.toString()
}

export function getBetterAuthSessionUrl(baseURL: string): string {
  const url = new URL(baseURL)
  const basePath = url.pathname.replace(/\/+$/, '')
  const authPath = basePath.endsWith('/api/auth') ? basePath : `${basePath}/api/auth`

  url.pathname = `${authPath}/get-session`
  url.search = ''
  url.hash = ''
  return url.toString()
}
